export function boldStylePlugin() {
    return {
        customStyleMap: {
            BOLD: {
                fontFamily: 'Hind-Bold'
            }
        }
    };
}

